'use strict';
import {NavigationBarHOC} from '../../../components/views/NavigationBar';
import {RequirementNavigationBarView} from './RequirementNavigationBarView';


export const RequirementNavigationBarContainer = NavigationBarHOC(RequirementNavigationBarView);



// WEBPACK FOOTER //
// ./src/js/requirements/components/RequirementNavigationBar/RequirementNavigationBarContainer.js